module.exports = __webpack_public_path__ + "img/jiagou4.06d3d9f3.png";